import { useQuery } from '@tanstack/react-query';
import { REACT_QUERY_KEYS_ONE_ON_ONE_INSIGHTS } from 'screens/oneOnOneRabbit/Insights/constants/reactQueryKeysOneOnOneInsights';
import { OneOnOneInsightsRequestI } from 'screens/oneOnOneRabbit/Insights/interfaces';

import { getOneOnOneInsightsTabularData } from '../services';

export const useOneOnOneInsightsTabularData = ({
  isExpandedViewRequired,
  cohort,
  dateRange,
  groupByKeys,
  orderBy,
}: OneOnOneInsightsRequestI) =>
  useQuery(
    [REACT_QUERY_KEYS_ONE_ON_ONE_INSIGHTS.oneOnOneInsightsTabularData, cohort?.id, dateRange, groupByKeys?.keyName],
    () =>
      getOneOnOneInsightsTabularData({
        isExpandedViewRequired,
        cohort,
        dateRange,
        groupByKeys,
        orderBy,
      }),
    {
      enabled: !!cohort?.id,
    }
  );
